// extracted by mini-css-extract-plugin
export default {"root":"root--Txf4z","btnWrap":"btnWrap--K_jvh","errorMsg":"errorMsg--VuyoL","errorWrap":"errorWrap--I76LW","paxThresholdErrorMessage":"paxThresholdErrorMessage--QF9F_"};